import Card from '../../components/Card/Card';
import { useHistory } from 'react-router';
import BackButton from '../../components/BackButton/BackButton';
import { FC } from 'react';
import styles from './BackCardLayout.module.scss';

type TBackCardLayoutProps = {
    onGoBack?: () => void;
};

const BackCardLayout: FC<TBackCardLayoutProps> = (props) => {
    const { children, onGoBack } = props;
    const history = useHistory();

    const handleGoBack = () => {
        onGoBack ? onGoBack() : history.goBack();
    };

    return (
        <>
            <nav className={styles.back}>
                <BackButton onGoBack={handleGoBack} />
            </nav>

            <Card>
                <main>{children}</main>
            </Card>
        </>
    );
};

export default BackCardLayout;
